import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class GridService {
  currentDefinition: any;
  certificateStates;
  currentGrid;
  userStates;
  userRoles;
  gridTranslations;
  customIcons = {
    menu:
      '<img src="assets/img/funnel.svg" alt="funnel-filter" class="funnel-icon"/>',
    filter: '<span></span>'
  };

  certificates = [];
  armCertificates = [];
  users = [];

  // TODO: refactorizar
  certificatesTagColors = {
    PR: '#e4ae07',
    8: '#eb5757',
    10: '#27ae60',
    22: '#c97a04',
    23: '#790995',
    REC: '#790a95',
    24: '#1b087d'
  };

  constructor(private translate: TranslateService, private datePipe: DatePipe) {
    this.translate.get('grid').subscribe(res => {
      this.gridTranslations = res;
    });

    this.translate.get('certificateStates').subscribe(res => {
      this.certificateStates = res;
    });

    this.translate.get('rolesModal.roles').subscribe(res => {
      this.userRoles = res;
    });

    this.translate.get('userStates').subscribe(res => {
      this.userStates = res;
    });
    this.initColumns();
  }

  initColumns() {
    this.certificates = [
      {
        headerName: this.gridTranslations['certificateNumber'],
        field: 'certificateNumber',
        cellStyle: {
          fontWeight: 'bold',
          color: '#333333'
        },
        filter: 'inputColumnCertificateFilterComponent',
        filterParams: {
          applyButton: false,
          clearButton: false
        },
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        unSortIcon: true,
        resizable: true,
        sortingOrder: ['asc', 'desc'],
        icons: this.customIcons
      },
      {
        headerName: this.gridTranslations['companyName'],
        field: 'companyName',
        filter: 'inputColumnCertificateFilterComponent',
        filterParams: {
          applyButton: false,
          clearButton: false
        },
        resizable: true,
        unSortIcon: true,
        sortingOrder: ['asc', 'desc'],
        icons: this.customIcons
      },
      {
        headerName: this.gridTranslations['certificate'],
        field: 'certificate',
        unSortIcon: true,
        resizable: true,
        sortingOrder: ['asc', 'desc'],
        cellRenderer: date => {
          return `<div style="display: flex; align-items: center; justify-content: center">
              <p style="color: #333333;">
              ${date.value !== undefined ? this.datePipe.transform(date.value, 'dd/MM/yyyy') : 'N/A'}
              </p>
            </div>`;
        },
        icons: this.customIcons
      },
      {
        headerName: this.gridTranslations['date'],
        field: 'date',
        unSortIcon: true,
        resizable: true,
        sortingOrder: ['asc', 'desc'],
        cellRenderer: date => {
          const today = new Date(Date.now());
          if (date.value <= today.toISOString()) {
            return (
              `<div style="display: flex; align-items: center; justify-content: center">
                <p style="color:red;">
                ${date.value !== null ? this.datePipe.transform(date.value, 'dd/MM/yyyy') : 'N/A'}
                </p>
                <img
                  class="alert-icon ml-2 mb-3"
                  style="width: 1rem;height: 1rem;"
                  src="assets/img/red-alert-icon.svg"
                  alt="cloud"
                />
              </div>`
            );
          } else {
            return (
              `<div style="display: flex; align-items: center; justify-content: center">
                <p style="color:'#333333';">
                ${date.value !== null ? this.datePipe.transform(date.value, 'dd/MM/yyyy') : 'N/A'}
                </p>
              </div>`
            );

          }
        },
        icons: this.customIcons
      },
      {
        headerName: this.gridTranslations['dateCreated'],
        field: 'dateCreated',
        unSortIcon: true,
        resizable: true,
        sortingOrder: ['asc', 'desc'],
        cellRenderer: date => {
          if (date.value.includes('/')) {
            return `<div style="display: flex; align-items: center; justify-content: center">
            <p style="color: #333333;">
            ${date.value !== null ? date.value : 'N/A'}
            </p>
            </div>`;
          } else {
            return `<div style="display: flex; align-items: center; justify-content: center">
            <p style="color: #333333;">
            ${date.value !== null ? this.datePipe.transform(date.value, 'dd/MM/yyyy') : 'N/A'}
            </p>
          </div>`;
          }
        },
        icons: this.customIcons
      },
      {

        headerName: this.gridTranslations['typeOperator'],
        field: 'typeOperator',
        filter: 'inputColumnCertificateFilterComponent',
        filterParams: {
          applyButton: false,
          clearButton: false
        },
        resizable: true,
        unSortIcon: true,
        sortingOrder: ['asc', 'desc'],
        icons: this.customIcons
      },
      {

        headerName: this.gridTranslations['country'],
        field: 'country',
        unSortIcon: true,
        resizable: true,
        sortingOrder: ['asc', 'desc'],
        cellStyle: {
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start'
        },
        filter: 'checkboxCertificateFilterComponent',
        filterParams: { defaultToNothingSelected: true },

        cellRenderer: params => {
          return params != null && params.value && params.value.code ? `<p style="padding-left: 2rem;">
              <span
                class="flag-icon flag-icon-${params.value.code.toLowerCase()}"
                style="padding-left: 2em;"
              >${params.value.shortName}</span>
            </span></p>` : "<div></div>";
        },
        icons: this.customIcons,
        comparator: this.countryComparator
      },
      {
        headerName: this.gridTranslations['edit'],
        field: 'edit',
        resizable: true,
        cellRenderer: edit => {
          const isEditing = edit.value === this.gridTranslations.edited;
          if (isEditing) {
            return `<span class="material-icons" style='color: #e4ae07'>edit</span>`;
          }
          return '';
        },
        unSortIcon: true,
        sortingOrder: ['asc', 'desc'],
      },
      {
        headerName: this.gridTranslations['status'],
        field: 'status',
        filter: 'checkboxCertificateFilterComponent',

        resizable: true,
        cellRenderer: status => {
          return `<div style="display: flex; align-items: center; justify-content: center">
              <p
              style=
                "background-color:${this.certificatesTagColors[status.value.code]
            };
                border-radius: 20px;
                width: 95px;
                line-height: 28px;
                text-align: center;
                margin: 0;
                position: absolute;
                top: 50%;
                -ms-transform: translateY(-50%);
                transform: translateY(-50%);
                color: white"
              >
                ${status.value.shortName}
              </p>
            </div>`;
        },
        unSortIcon: true,
        sortingOrder: ['asc', 'desc'],
        icons: this.customIcons,
        comparator: this.statusComparator
      }
    ];

    this.armCertificates = [
      {
        headerName: "PAIS",
        field: 'country',
        cellStyle: {
          fontWeight: 'bold',
          color: '#333333'
        },
        filter: 'inputColumnCertificateFilterComponent',
        filterParams: {
          applyButton: false,
          clearButton: false
        },
        cellRenderer: params => {
          console.log(params)
          return `
          <p style='padding-top: 15px'>
              <span
                class="flag-icon flag-icon-${params.value.code.toLowerCase()}"
                style="padding-left: 2em;"
              ></span>
            </span>${params.value.shortName}</p>`;
        },
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        unSortIcon: true,
        resizable: true,
        sortingOrder: ['asc', 'desc'],
        icons: this.customIcons
      }, {
        headerName: "DID",
        field: 'country.did',
        cellStyle: {
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start'
        },
        filter: 'inputColumnCertificateFilterComponent',
        filterParams: {
          applyButton: false,
          clearButton: false
        },
        headerCheckboxSelection: false,
        headerCheckboxSelectionFilteredOnly: false,
        checkboxSelection: false,
        unSortIcon: true,
        resizable: true,
        sortingOrder: ['asc', 'desc'],
        icons: this.customIcons
      }, {
        headerName: "FECHA DEL ARM",
        field: 'certificationDate',
        cellStyle: {
          display: 'flex',
          alignItems: 'flex-start',
          textAlign: "center"
        },
        filter: 'inputColumnCertificateFilterComponent',
        filterParams: {
          applyButton: false,
          clearButton: false
        },
        cellRenderer: date => {
          return `<div style="display: flex; align-items: center; justify-content: center">
              <p style="color: #333333;">
              ${date.value !== undefined ? this.datePipe.transform(date.value, 'dd/MM/yyyy') : 'N/A'}
              </p>
            </div>`;
        },
        headerCheckboxSelection: false,
        headerCheckboxSelectionFilteredOnly: false,
        checkboxSelection: false,
        unSortIcon: true,
        resizable: true,
        sortingOrder: ['asc', 'desc'],
        icons: this.customIcons
      },
      {
        headerName: "FECHA DE CREACIÓN",
        field: 'creationDate',
        cellStyle: {
          display: 'flex',
          alignItems: 'flex-start',
          textAlign: "center"
        },
        filter: 'inputColumnCertificateFilterComponent',
        filterParams: {
          applyButton: false,
          clearButton: false
        },
        cellRenderer: date => {
          return `<div style="display: flex; align-items: center; justify-content: center">
              <p style="color: #333333;">
              ${date.value !== undefined ? this.datePipe.transform(date.value, 'dd/MM/yyyy') : 'N/A'}
              </p>
            </div>`;
        },
        headerCheckboxSelection: false,
        headerCheckboxSelectionFilteredOnly: false,
        checkboxSelection: false,
        unSortIcon: true,
        resizable: true,
        sortingOrder: ['asc', 'desc'],
        icons: this.customIcons
      },
      // {
      //   headerName: "FECHA DE EXPIRACIÓN",
      //   field: 'expirationDate',
      //   cellStyle: {
      //     display: 'flex',
      //     alignItems: 'flex-start',
      //     textAlign: "center"
      //   },
      //   filter: 'inputColumnCertificateFilterComponent',
      //   filterParams: {
      //     applyButton: false,
      //     clearButton: false
      //   },
      //   headerCheckboxSelection: false,
      //   headerCheckboxSelectionFilteredOnly: false,
      //   checkboxSelection: false,
      //   unSortIcon: true,
      //   resizable: true,
      //   sortingOrder: ['asc', 'desc'],
      //   icons: this.customIcons
      // },
      {
        headerName: this.gridTranslations['status'],
        field: 'status',
        filter: 'checkboxCertificateFilterComponent',

        resizable: true,
        cellRenderer: status => {
          console.log("STATUS", status);
          const statusDescriptionMap = new Map([
            ["REVOKED", "Rechazado"],
            ["CERTIFIED", "Vigente"],
            ["PENDING_REVIEW", "Pendiente de Revisión"],
            ["AWAITING_RESPONSE", "Esperando Respuesta"]
          ]);

          const statusColor = new Map([
            ["REVOKED", "danger"],
            ["CERTIFIED", "success"],
            ["PENDING_REVIEW", "warning"],
            ["AWAITING_RESPONSE", "info"]
          ])
          return `<div style="display: flex; align-items: center; justify-content: center">
              <p
              class="bg-${statusColor.get(status.value)}"
              style=
                "border-radius: 20px;
                width: auto;
                padding-left: 5px;
                padding-right: 5px;
                line-height: 28px;
                text-align: center;
                margin: 0;
                position: absolute;
                top: 50%;
                -ms-transform: translateY(-50%);
                transform: translateY(-50%);
                color: white"
              >
                ${statusDescriptionMap.get(status.value)}
              </p>
            </div>`;
        },
        unSortIcon: true,
        sortingOrder: ['asc', 'desc'],
        icons: this.customIcons,
        comparator: this.statusComparator
      }

      // {
      //   headerName: this.gridTranslations['companyName'],
      //   field: 'companyName',
      //   filter: 'inputColumnCertificateFilterComponent',
      //   filterParams: {
      //     applyButton: false,
      //     clearButton: false
      //   },
      //   resizable: true,
      //   unSortIcon: true,
      //   sortingOrder: ['asc', 'desc'],
      //   icons: this.customIcons
      // }
    ]

    this.users = [
      {
        headerName: 'ID',
        field: 'id',
        hide: true,
        resizable: true,
        icons: this.customIcons,
      },

      {
        headerName: this.gridTranslations['name'],
        field: 'name',
        filter: 'inputColumnFilterComponent',
        filterParams: {
          applyButton: false,
          clearButton: false
        },
        unSortIcon: true,
        sortingOrder: ['asc', 'desc'],
        headerCheckboxSelection: true,
        resizable: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        icons: this.customIcons
      },
      {
        headerName: this.gridTranslations['email'],
        field: 'email',
        resizable: true,
        filter: 'inputColumnFilterComponent',
        unSortIcon: true,
        sortingOrder: ['asc', 'desc'],
        icons: this.customIcons
      },
      {
        headerName: this.gridTranslations['role'],
        field: 'role',
        filter: 'checkboxFilterComponent',
        width: 340,
        unSortIcon: true,
        resizable: true,
        sortingOrder: ['asc', 'desc'],
        icons: this.customIcons,
        cellRenderer: status => {
          return this.userRoles[status.data.roleCode].shortName;
        }
      },
      {
        headerName: this.gridTranslations['status'],
        field: 'status',
        filter: 'checkboxFilterComponent',
        cellRenderer: params => this.getStatusCell(params),
        unSortIcon: true,
        resizable: true,
        sortingOrder: ['asc', 'desc'],
        icons: this.customIcons
      }
    ];
  }



  private statusComparator(statusA: any, statusB: any) {
    const descriptionA: string = statusA.description;
    const descriptionB: string = statusB.description;
    return descriptionA.localeCompare(descriptionB);
  }

  private countryComparator(countryA: any, countryB: any) {
    const descriptionA: string = countryA.shortName;
    const descriptionB: string = countryB.shortName;
    return descriptionA.localeCompare(descriptionB);
  }

  usersTagColors = {
    H: '#27ae60',
    P: '#e4ae07',
    D: '#650219'
  };
  getStatusCell(params) {
    return `<div style="display: flex; align-items: center; justify-content: center"><p
        style=
          "background-color:${this.usersTagColors[params.value]};
          border-radius: 20px;
          width: 95px;
          line-height: 28px;
          text-align: center;
          margin: 0;
          margin-right: 50%;
          position: absolute;
          top: 50%;
          -ms-transform: translateY(-50%);
          transform: translateY(-50%);
          color: white"
      >
        ${this.userStates[params.data.status].shortName}
      </p></div>`;
  }

  getColumnDefs(grid) {
    this.currentGrid = grid;
    return this[grid];
  }

  get currentDef() {
    return this.currentGrid;
  }
}
